import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../enums/eEventTypes';
import eVideoTypes from '../enums/eVideoTypes';

export default class BackgroundContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        // this.createTweens();
        // if (!PIXI.isMobile.any)
            this.initAnimation();
        this.active = false;
        this.addListeners();
    }

    init() {
        // this.freeSpinsBackground = this.getChildByName('freeSpinsBackground');
        // this.freeSpinsBackground.visible = false;
    }
    addListeners() {
        GlobalDispatcher.addOnce(eEventTypes.EET_START_SCREEN__STATE__END, this.onStartScreenEnd, this);
        GlobalDispatcher.add(eEventTypes.EBET_BIG_WIN_ANIMATION_VISIBLE_CHANGE, this.setVideoContainer, this);

        window.OPWrapperService.eventManager.add(
          window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
          this.onResize,
          this
        );
    }

    setVideoContainer({ params: overlayVisible }) {
        if (overlayVisible) {
            this.getChildByName('animationContainer').removeChild(this.videoSprite);
        } else {
            this.getChildByName('animationContainer').addChild(this.videoSprite);
        }
    }

    onResize (data) {
        const frame = data.isPortrait ? 1 : 2;
        this.goToFrame(frame);
        if (!this.videoControler) return;
        if (data.isPortrait) {
            // this.getChildByName('animationContainer').removeChild(this.videoSprite);
                // this.videoControler.pause();
                this.videoSprite.y = -630;
                this.videoSprite.scale.set(3.96);
        } else {
            // this.getChildByName('animationContainer').addChild(this.videoSprite);
                this.videoSprite.scale.set(1.828);
                this.videoSprite.y = 0;
                this.play();
        }
    }

    onStartScreenEnd() {
        this.startScreenClosed = true;
        this.play();
    }

    play() {
        if (this.startScreenClosed) this.videoControler.play();
    }

    initAnimation() {
        // this.animation = new PIXI.VideoResource('assets/animations/video/backgroundFire.mp4', {autoPlay: true});
        const texture = PIXI.Assets.get(eVideoTypes.BACKGROUND_FIRE);
        this.videoSprite = new PIXI.Sprite( texture );
        this.videoSprite.filters = [new PIXI.AlphaFilter()];
        this.videoSprite.filters[0].blendMode = PIXI.BLEND_MODES.ADD;
        this.videoSprite.blendMode = PIXI.BLEND_MODES.ADD;
        // this.videoSprite.texture.blendMode = PIXI.BLEND_MODES.ADD;
        // this.videoSprite.texture.baseTexture.alphaMode = PIXI.ALPHA_MODES.PREMULTIPLIED_ALPHA;
        this.videoSprite.scale.set(1.828);
        this.videoControler = this.videoSprite.texture.baseTexture.resource.source;
        this.videoControler.loop = true;
        this.getChildByName('animationContainer').addChild(this.videoSprite);
    }
}
